import classNames from 'classnames';
import React from 'react';
import { errorGlowText, primary } from '../../Styles/Colours';
import styles from './StaticNavMenu.module.css';
export var StaticNavMenuItem = function (props) {
    var _a, _b;
    var displayErrors = !!props.errors && props.errors > 0;
    var linkStyles = classNames(styles.link, (_a = {},
        _a[styles.linkActive] = props.isActive && !props.disabled,
        _a[styles.linkDisabled] = props.disabled,
        _a[styles.linkActiveErrored] = props.isActive && displayErrors,
        _a[styles.linkErrored] = !props.isActive && displayErrors,
        _a));
    var textClass = classNames(styles.text, (_b = {},
        _b[styles.navCollapses] = props.isCollapsed,
        _b[styles.textDisabled] = props.disabled,
        _b[styles.textErrored] = displayErrors,
        _b));
    return (React.createElement("div", { onClick: props.disabled ? undefined : props.onClick, className: linkStyles, "data-test-id": props.testId },
        React.cloneElement(props.icon, displayErrors ? { color: errorGlowText } : props.isActive ? { color: primary } : undefined),
        React.createElement("div", { className: textClass }, props.title),
        displayErrors &&
            (props.isCollapsed ? (React.createElement("div", { className: styles.miniBadge })) : (React.createElement("div", { className: styles.errorBadge }, props.errors)))));
};
